import React, { useRef, useEffect, DetailedHTMLProps, HTMLAttributes } from 'react';

function assertIsNode(e: EventTarget | null): asserts e is Node {
  if (!e || !('nodeType' in e)) {
    throw new Error(`Node expected`);
  }
}

export const OutsideClick: React.FC<OutsideClickProps> = ({
  children,
  onClickOutside,
  ...rest
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: DocumentEventMap['click'] | DocumentEventMap['touchend']) {
      assertIsNode(event.target);

      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClickOutside(event);
      }
    }

    document.addEventListener('click', handleClickOutside, { capture: true });
    document.addEventListener('touchend', handleClickOutside, { capture: true });

    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('touchend', handleClickOutside);
    };
  }, []);

  return (
    <div ref={wrapperRef} {...rest}>
      {children}
    </div>
  );
};

type OutsideClickProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
  onClickOutside: (event: MouseEvent | TouchEvent) => any;
};
